module.exports = __webpack_public_path__ + "static/media/掌沃.412458c1.png";